/**
 * Home Dashboard shimmer skeleton — iter-85.
 *
 * Renders a layout-faithful placeholder while the home page's data fetches
 * resolve in parallel. Replaces the previous blank LoadingScreen so the user
 * sees stable structure immediately (no FOUC, no jumping).
 */
export default function HomeSkeleton() {
  return (
    <div className="p-5 pb-28 animate-pulse" data-testid="home-skeleton">
      {/* Hero card */}
      <div className="rounded-3xl p-5 bg-gradient-to-br from-[#7E5BEF] to-[#4F46E5] relative overflow-hidden">
        <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/15" />
        <div className="h-2 w-24 rounded-full bg-white/20" />
        <div className="mt-2 flex items-center gap-2">
          <div className="h-5 w-20 rounded-full bg-white/15" />
          <div className="h-3 w-24 rounded-full bg-white/10" />
        </div>
        <div className="mt-4 flex items-center gap-4">
          <div className="h-6 w-20 rounded bg-white/15" />
          <div className="h-6 w-px bg-white/20" />
          <div className="h-6 w-28 rounded bg-white/15" />
        </div>
        <div className="mt-5 bg-white/10 rounded-2xl p-3">
          <div className="h-3 w-20 rounded-full bg-white/15" />
          <div className="mt-2 h-5 w-3/4 rounded bg-white/20" />
          <div className="mt-4 h-2 w-full rounded-full bg-white/15">
            <div className="h-full w-1/3 rounded-full bg-[#FFC800]/40" />
          </div>
          <div className="mt-3 h-3 w-2/3 rounded-full bg-white/15" />
          <div className="mt-1 h-2 w-1/3 rounded-full bg-white/10" />
        </div>
        <div className="flex items-center justify-center gap-1.5 mt-2.5">
          <div className="h-1.5 w-4 rounded-full bg-white" />
          <div className="h-1.5 w-1.5 rounded-full bg-white/40" />
          <div className="h-1.5 w-1.5 rounded-full bg-white/40" />
        </div>
      </div>

      {/* Quick actions strip */}
      <div className="flex items-center gap-2 mt-4 mb-3">
        <div className="h-8 w-24 rounded-full bg-[#E2E8F0]" />
        <div className="h-8 w-24 rounded-full bg-[#E2E8F0]" />
      </div>

      {/* Today's mission card */}
      <div className="gm-card p-4 space-y-3">
        <div className="flex items-center gap-2">
          <div className="h-4 w-32 rounded-full bg-[#E2E8F0]" />
          <div className="ml-auto h-5 w-16 rounded-full bg-[#E2E8F0]" />
        </div>
        <div className="h-6 w-4/5 rounded bg-[#E2E8F0]" />
        <div className="h-3 w-full rounded bg-[#F1F5F9]" />
        <div className="h-3 w-3/4 rounded bg-[#F1F5F9]" />
        <div className="flex items-center gap-2 mt-2">
          <div className="h-10 flex-1 rounded-2xl bg-[#E2E8F0]" />
          <div className="h-10 w-10 rounded-2xl bg-[#E2E8F0]" />
        </div>
      </div>

      {/* Weekly challenge teaser */}
      <div className="mt-4 gm-card p-4 space-y-2">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-xl bg-[#E2E8F0]" />
          <div className="h-4 w-40 rounded-full bg-[#E2E8F0]" />
        </div>
        <div className="h-3 w-2/3 rounded bg-[#F1F5F9]" />
      </div>

      {/* Park lot teaser */}
      <div className="mt-5 gm-card p-3 space-y-2">
        <div className="h-3 w-24 rounded-full bg-[#E2E8F0]" />
        <div className="h-12 w-full rounded-xl bg-[#F1F5F9]" />
        <div className="h-12 w-full rounded-xl bg-[#F1F5F9]" />
      </div>
    </div>
  );
}
